import { AxiosError } from 'axios'
import { toast } from '@/hooks/use-toast'
import i18n from '@/i18n'
import { Sentry } from '@/sentry'

export function handleServerError(error: unknown) {
  // eslint-disable-next-line no-console
  console.log(error)

  let errMsg = 'Something went wrong!'

  if (
    error &&
    typeof error === 'object' &&
    'status' in error &&
    Number(error.status) === 204
  ) {
    errMsg = 'Content not found.'
  }

  if (error instanceof AxiosError) {
    // Handle 429 Too Many Requests error specifically
    if (error.response?.status === 429) {
      errMsg = 'طلبات كثيرة جداً. يرجى المحاولة مرة أخرى بعد قليل.'
    } else {
      const data = error.response?.data
      const detailsError = data?.details?.error
      errMsg =
        (Array.isArray(detailsError) ? detailsError[0] : detailsError) ??
        data?.message ??
        data?.error ??
        i18n.t('serv_error')
    }
  }

  // Report to Sentry (if not already captured)
  Sentry.addBreadcrumb({
    category: 'error-handler',
    message: 'Server error handled',
    level: 'error',
    data: {
      errorMessage: errMsg,
    },
  })
  
  // Capture the error if it's significant
  if (error instanceof AxiosError && error.response) {
    const status = error.response.status
    // Only capture errors that aren't already handled elsewhere
    if (![401, 403, 429, 402].includes(status)) {
      Sentry.captureException(error)
    }
  } else if (error) {
    Sentry.captureException(error)
  }

  toast({ variant: 'destructive', title: errMsg })
}
